<template>
  <div>
    <el-table :data="pageData.data" style="width: 100%" height="60vh" border>
      <el-table-column prop="services_id" label="编号" width="200"></el-table-column>
      <el-table-column prop="name" label="姓名" width="100"></el-table-column>
      <el-table-column prop="tel" label="电话" width="150"></el-table-column>
      <el-table-column prop="house_name" label="项目" width="150"></el-table-column>
      <el-table-column prop="address" label="位置" width="320"></el-table-column>
      <el-table-column prop="content" label="报修内容" width="200" show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="类型" width="100">
        <template slot-scope="scope">
          <template v-if="scope.row.site == 1">
            公区维修
          </template>
          <template v-if="scope.row.site == 2">
            居家报修
          </template>
          <template v-if="scope.row.site == 4">
            公区卫生
          </template>
          <template v-if="scope.row.site == 8">
            公区安全
          </template>
          <template v-if="scope.row.site == 16">
            公区绿化
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="member_type_text" label="工单来源" width="100"></el-table-column>
      <el-table-column prop="pics" label="处理前" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.pics.length > 0" :src="scope.row.pics[0]" :preview-src-list="scope.row.pics" fit="contain" style="width: 100px;height: 100px;"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="after_pics" label="处理后" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.after_pics.length > 0" :src="scope.row.after_pics[0]" :preview-src-list="scope.row.after_pics" fit="contain" style="width: 100px;height: 100px;"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="is_timeout_text" label="预警" width="100"></el-table-column>
      <el-table-column prop="status_text" label="状态" width="100"></el-table-column>
      <el-table-column prop="created_at_text" label="提交时间" width="180"></el-table-column>
      <el-table-column prop="comment" label="评价" width="180"></el-table-column>
<!--      <el-table-column label="操作" width="100" fixed="right">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button style="color: #FFFFFF" type="primary" size="mini" @click="getDetail(scope.row)">查看-->
<!--          </el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div>
      <el-pagination
        layout="prev, pager, next"
        :current-page="pageData.current_page"
        :page-size="pageData.per_page"
        :total="pageData.total"
        @current-change="pageChang"></el-pagination>
    </div>
  </div>
</template>

<script>
import ButlerHttp from "../Butler/common/ButlerHttp";

export default {
  name: "report-repairs",
  props: {
    id: {
      type: String|Number,
      required: true,
      default: 0
    },
  },
  data() {
    return {
      pageData:{
        current_page:1,
        per_page:10,
        total:0,
        data:[]
      }
    };
  },
  mounted() {
    this.pageChang(1);
  },
  methods: {
    getList(){
      const that = this;
      ButlerHttp.post("ButlerCustomer/getReportRepairsList",{
        customer_id:this.id,
        page:that.pageData.current_page,
      },(res) => {
        if(res.code){
          that.pageData = res.data;
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    pageChang(page){
      this.pageData.current_page = page;
      this.getList();
    },
    getDetail(row){}
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/report-repairs.vue